import { LoadingPageIcon } from '@/assets/icons/loading-page-icon'
import { Show } from '@/components/show'

interface PageLoadingProps {
  goingTo: string
  withText?: boolean
}

export const PageLoading = ({ goingTo, withText }: PageLoadingProps) => {
  return (
    <div className="w-full h-[calc(100vh-80px)] bg-background text-[var(--brand-blue-3)] flex flex-col gap-5 justify-center items-center">
      <LoadingPageIcon />
      <Show when={withText}>
        <p className="text-3xl font-bold">Indo para &quot;{goingTo}&quot;</p>
      </Show>
    </div>
  )
}
